import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, orange, unityOrange } from '../colors';
import { GetThemeOptions } from '../../theme';

export const warningColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityOrange[400],
          highContrast: unityOrange[700],
          lowContrast: unityOrange[100],
        }
      : {
          main: unityOrange[400],
          highContrast: unityOrange[100],
          lowContrast: unityOrange[800],
        };
  }

  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
